var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('doughnut-chart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }